
type PossibleAlertTypes = 'success' | 'warning' | 'error';

export default {
  name: 'ServerErrorAlert',

  props: {
    serverResponse: {
      type: Object,
      default: (): Record<string, unknown> => ({}),
    },
  },

  data(): Record<string, unknown> {
    return {
      alertTypes: {
        '200': 'success',
        '400': 'warning',
        '500': 'error',
      },
      alertWithResponse: {
        visible: false,
        message: '',
        description: '',
        code: null,
      },
    };
  },

  computed: {
    alertType(): PossibleAlertTypes {
      return this.deductAlertType();
    },
  },

  watch: {
    serverResponse(): void {
      Object.keys(this.serverResponse).length
        ? this.createResponseAlert(this.serverResponse)
        : this.resetResponseAlert();
    },
  },

  methods: {
    createResponseAlert(serverResponse: {
      data: {
        message: string;
        description?: string;
      };
      status: number;
      ok: boolean;
    }): void {
      this.alertWithResponse.visible = true;
      this.alertWithResponse.message = serverResponse.data.message;
      this.alertWithResponse.description = serverResponse.data.description;
      this.alertWithResponse.code = serverResponse.status;
    },

    resetResponseAlert(): void {
      this.alertWithResponse.visible = false;
      this.alertWithResponse.message = '';
      this.alertWithResponse.description = '';
      this.alertWithResponse.code = null;
    },

    deductAlertType(): PossibleAlertTypes {
      let alertType: PossibleAlertTypes;

      Object.entries(this.alertTypes).forEach((entry: [string, PossibleAlertTypes]) => {
        enum alert {
          httpCode,
          type,
        }

        if (this.alertWithResponse.code >= parseInt(entry[alert.httpCode])) {
          alertType = entry[alert.type];
        }
      });

      return alertType;
    },
  },
};
